/**
 * @author shaojingchao
 * @date 2018/12/7
 * @project kaoshizhongxin
 */
import Vue from 'vue'
import NoticeComponent from './notice.vue'

// defaults config
const TYPE = ''
const DURATION = 3 // s
let zIndex = 3000

const NoticeCtor = Vue.extend(NoticeComponent)
let instancePool = []

let getAnInstance = () => {
  return instancePool.length > 0 ? instancePool.shift() : new NoticeCtor().$mount()
}

let closedInstanceAddToPool = instance => (instance && instancePool.push(instance))

NoticeCtor.prototype.$_remove = function () {
  closedInstanceAddToPool(this)
  return this
}

let Notice = (options = {}) => {
  let instance = getAnInstance()
  clearTimeout(instance.$_timer)
  let duration = options.duration || DURATION
  instance.zIndex = zIndex++
  instance.message = typeof options === 'string' ? options : options.message
  instance.type = options.type || TYPE
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.visible = true
    if (duration > 0) {
      instance.$_timer = setTimeout(() => {
        instance.visible = false
      }, duration * 1000)
    }
  })
  return instance
}

export default Notice
